import { render, staticRenderFns } from "./treeNavItem.vue?vue&type=template&id=8944a536&scoped=true&"
import script from "./treeNavItem.vue?vue&type=script&lang=js&"
export * from "./treeNavItem.vue?vue&type=script&lang=js&"
import style0 from "./treeNavItem.vue?vue&type=style&index=0&id=8944a536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8944a536",
  null
  
)

component.options.__file = "treeNavItem.vue"
export default component.exports